<template>
	<Slider :sliders="sliders"></Slider>
</template>

<script>
import Slider from "@/components/Pages/CategorySlider";

export default {
	components: { Slider },

	data() {
		return {
			sliders: [
				{
					title: "Vinilica",
					color: "#D3007D",
					name: "plastic",
					categories: [3, 45],
					img: "/img/plastic.png",
					description:
						"Pintura acrílica perfecta para conseguir un fino acabado semimate. Evita mantenimiento constante atraves de su alta protección y resistencia.",
				},

				{
					title: "Vinilica",
					color: "#B0721B",
					name: "mil",
					categories: [3],
					img: "/img/mil.png",
					description:
						"Pintura acrílica perfecta para conseguir un fino acabado semimate. Evita mantenimiento constante atraves de su alta protección y resistencia.",
				},

				{
					title: "Vinilica",
					color: "#9A7D4B",
					name: "gold",
					categories: [3],
					img: "/img/gold.png",
					description:
						"Pintura acrílica perfecta para conseguir un fino acabado semimate. Evita mantenimiento constante atraves de su alta protección y resistencia.",
				},

				{
					title: "Vinilica",
					color: "#7E2685",
					name: "master",
					categories: [3, 46],
					img: "/img/master.png",
					description:
						"Pintura acrílica perfecta para conseguir un fino acabado semimate. Evita mantenimiento constante atraves de su alta protección y resistencia.",
				},

				{
					title: "Vinilica",
					color: "#E4004C",
					name: "classic",
					categories: [3, 47],
					img: "/img/classic.png",
					description:
						"Pintura acrílica perfecta para conseguir un fino acabado semimate. Evita mantenimiento constante atraves de su alta protección y resistencia.",
				},

				{
					title: "Vinilica",
					color: "#00842E",
					name: "acuacover",
					categories: [3, 50],
					img: "/img/acuacover.png",
					description:
						"Pintura Vinil-Acrílica elaborada con materiales de la más alta calidad, excelente acabado mate y poder cubriente.",
				},

				{
					title: "Vinilica",
					color: "#0099D9",
					name: "color price",
					categories: [3, 49],
					img: "/img/colorprice.png",
					description:
						"Pintura vinil-Acrílica emulsionad. Perfecta para conseguir acabados mate al mejor precio.",
				},

				{
					title: "Vinilica",
					color: "#C87CB0",
					name: "sellamuro entintable",
					categories: [3, 43],
					img: "/img/sellamuroentintable.png",
					description:
						"Recubrimiento color blanco mate. Fabricado con resina acrílica libre de plomo y excelente desempeño. Ideal para decorar y proteger espacios.",
				},

				{
					title: "Vinilica",
					color: "#028CCA",
					name: "sellamuro 501",
					categories: [3, 73],
					img: "/img/501.png",
					description:
						"Excelente sellador, creado para aumentar al máximo el tiempo de vida del acabado en las superficies, bloquea la porosidad y ayudando a obtener un mayor rendimiento total. Recomendado para áreas tratadas anteriormente que requieren de mantenimiento o repintado.",
				},
			],
		};
	},
};
</script>

<style lang="css" scoped></style>
